var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.42268 2.33317C3.42268 3.25384 2.65979 3.99984 1.71821 3.99984C0.776632 3.99984 0.0137457 3.25384 0.0137457 2.33317C0.0137457 1.41317 0.776632 0.666504 1.71821 0.666504C2.65979 0.666504 3.42268 1.41317 3.42268 2.33317ZM3.43643 5.33317H0V15.9998H3.43643V5.33317ZM8.92234 5.33317H5.5079V15.9998H8.92302V10.4005C8.92302 7.28717 13.0667 7.0325 13.0667 10.4005V15.9998H16.4948V9.24584C16.4948 3.9925 10.3629 4.18384 8.92234 6.76984V5.33317Z",
    fill: "#0077B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.73ca5058b019a454ad42e6d3a00267bf.svg";
export { ForwardRef as ReactComponent };